import gql from 'graphql-tag';

//  deprecated
const GETALL_PRIORITY = gql`
  query getAllPriority {
    getAllPriority {
      name
      id
      colorCode
    }
  }
`;
//  deprecated
const GETALL_IMPACT = gql`
  query getAllImpact {
    getAllImpact {
      name
      id
    }
  }
`;

//  deprecated
const GETALL_URGENCY = gql`
  query getAllUrgency {
    getAllUrgency {
      name
      id
    }
  }
`;

//  deprecated
const GETALL_STATUS = gql`
  query getAllStatus {
    getAllStatus {
      name
      id
    }
  }
`;

const GETALL_APPROVAL_STATUS = gql`
  query getAllApprovalStatus {
    getAllApprovalStatus {
      name
      approvalStatusId
      state
    }
  }
`;

const GET_TICKET_APPROVAL_STATUS = gql`
  query getTicketApprovalStatus {
    getTicketApprovalStatus {
      name
    }
  }
`;

//  deprecated
const GETALL_CAUSE = gql`
  query getAllCause {
    getAllCause {
      name
      id
      subCauses {
        id
        name
      }
    }
  }
`;

//  deprecated
const GETALL_CATEGORY = gql`
  query getAllCategory {
    getAllCategory {
      name
      id
      subCategories {
        id
        name
      }
    }
  }
`;

const GETALL_ISSUETYPES = gql`
  query getAllIssueType {
    getAllIssueType {
      name
      id
      subIssueTypes {
        id
        name
      }
    }
  }
`;

const GETALL_TICKET_ENTITY = gql`
  query entityProperties {
    Ticket
  }
`;

const GET_FIELD = gql`
  query getField($input: FieldIdentifierInput!) {
    getField(input: $input) {
      id
      label
      columnName
      description
      fieldType
      fieldCategory
      options {
        id
        value
        order
        description
        details
        parentOption {
          id
          value
        }
        deletable
      }
      showToClient
      module
      mandatoryOnCreate
      mandatoryOnClosure
      parentField {
        id
        module
        columnName
        label
        description
        fieldCategory
      }
    }
  }
`;

const GET_FIELD_FOR_DROPDOWN = gql`
  query getField($input: FieldIdentifierInput!) {
    getField(input: $input) {
      id
      label
      columnName
      options {
        id
        value
        details
      }
    }
  }
`;

export {
  GETALL_TICKET_ENTITY,
  GETALL_PRIORITY,
  GETALL_IMPACT,
  GETALL_URGENCY,
  GETALL_STATUS,
  GETALL_CAUSE,
  GETALL_CATEGORY,
  GETALL_ISSUETYPES,
  GETALL_APPROVAL_STATUS,
  GET_TICKET_APPROVAL_STATUS,
  GET_FIELD,
  GET_FIELD_FOR_DROPDOWN
};
